import { render, staticRenderFns } from "./withdrawshenhe.vue?vue&type=template&id=2fc245f9&scoped=true"
import script from "./withdrawshenhe.vue?vue&type=script&lang=js"
export * from "./withdrawshenhe.vue?vue&type=script&lang=js"
import style0 from "./withdrawshenhe.vue?vue&type=style&index=0&id=2fc245f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc245f9",
  null
  
)

export default component.exports